import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { RotinaService } from '../rotina.service';
import { ComumService } from '../../comum/comum.service';
import { AuthService } from '../../auth/auth.service';
import { ReincidenciaRotina } from '../../comum/modelos/reincidencia-rotina';
import { CriterioReincidenciaRotina } from '../../comum/modelos/criterio-reincidencia-rotina';
import { UsuarioService } from '../../usuario/usuario.service';
import { Usuario } from '../../comum/modelos/usuario';
import { CookieService } from 'angular2-cookie';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'app-reincidencia-rotina',
  templateUrl: './reincidencia-rotina.component.html',
  styleUrls: ['./reincidencia-rotina.component.css']
})
export class ReincidenciaRotinaComponent implements OnInit {

  @Input() idRotinaCliente: number;
  @Input() origem: string;
  @Output() reincidenciaRotinaEvent: EventEmitter<ReincidenciaRotina>;
  reincidenciaRotina: ReincidenciaRotina;
  criterios: CriterioReincidenciaRotina[];
  usuarios: Usuario[];
  selecionados = false;
  ultimosDias: boolean;
  ultimasSemanas: boolean;
  ultimosMeses: boolean;
  rangeDatas: boolean;

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  public statusCode: number;
  public loading = false;
  pt: any;
  dateFormat = 'dd/mm/yy';

  constructor(private _rotinaService: RotinaService,
    private _comumService: ComumService,
    public _authService: AuthService,
    private _cookieService: CookieService,
    private _usuarioService: UsuarioService,
    private confirmationService: ConfirmationService) {
    this.reincidenciaRotina = new ReincidenciaRotina();
    this.criterios = new Array<CriterioReincidenciaRotina>();
    this.usuarios = new Array<Usuario>();
    this.reincidenciaRotinaEvent = new EventEmitter<ReincidenciaRotina>();
  }

  ngOnInit() {
    this.loading = true;
    const self = this;
    self.pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'ter\xE7a', 'quarta', 'quinta', 'sexta', 's\xE1bado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\xE1b'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: ['janeiro', 'fevereiro', 'mar\xE7o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro',
        'outubro', 'novembro', 'dezembro'],
      monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      today: 'Hoje',
      clear: 'Apagar'
    };
    self._rotinaService.obterReincidenciaRotinaHttp(self.idRotinaCliente).subscribe(reincidencia => {
      self.reincidenciaRotina = reincidencia;
      self.reincidenciaRotina.idRotinaCliente = self.idRotinaCliente;

      if (self.reincidenciaRotina.dataInicioReferencia !== null && self.reincidenciaRotina.dataInicioReferencia !== undefined) {
        self.reincidenciaRotina.dataInicioReferencia = new Date(self.reincidenciaRotina.dataInicioReferencia);
        this.ultimosDias = false;
        this.ultimasSemanas = false;
        this.ultimosMeses = false;
        this.rangeDatas = true;
      }
      if (self.reincidenciaRotina.dataFimReferencia !== null && self.reincidenciaRotina.dataFimReferencia !== undefined) {
        self.reincidenciaRotina.dataFimReferencia = new Date(self.reincidenciaRotina.dataFimReferencia);
        this.ultimosDias = false;
        this.ultimasSemanas = false;
        this.ultimosMeses = false;
        this.rangeDatas = true;
      }
      if (self.reincidenciaRotina.diasAte !== null && self.reincidenciaRotina.diasAte !== undefined) {
        this.ultimosDias = true;
        this.ultimasSemanas = false;
        this.ultimosMeses = false;
        this.rangeDatas = false;
      }
      if (self.reincidenciaRotina.semanasAte !== null && self.reincidenciaRotina.semanasAte !== undefined) {
        this.ultimosDias = false;
        this.ultimasSemanas = true;
        this.ultimosMeses = false;
        this.rangeDatas = false;
      }
      if (self.reincidenciaRotina.mesesAte !== null && self.reincidenciaRotina.mesesAte !== undefined) {
        this.ultimosDias = false;
        this.ultimasSemanas = false;
        this.ultimosMeses = true;
        this.rangeDatas = false;
      }
      forkJoin(self._rotinaService.obterCriteriosAvaliacaoRotinaClienteHttp(self.idRotinaCliente),
        self._usuarioService.obterUsuariosHttp(parseInt(this._cookieService.get('idCliente'), 10)))
        .subscribe(([criterios, usuarios]) => {
          self.usuarios = usuarios;
          if (reincidencia.idReincidenciaRotina === null || reincidencia.idReincidenciaRotina === undefined) {
            self.MODO = this.CADASTRAR;
            for (const criterio of criterios) {
              const novoCriterioReincidencia = new CriterioReincidenciaRotina();
              novoCriterioReincidencia.criterioAvaliacaoRotinaCliente = criterio;
              novoCriterioReincidencia.idCriterioAvaliacaoRotinaCliente = criterio.idCriterioAvaliacaoRotinaCliente;
              self.criterios.push(novoCriterioReincidencia);
            }
          } else {
            self.MODO = this.ATUALIZAR;
            self.reincidenciaRotina = reincidencia;
            self.reincidenciaRotina.dataInicioReferencia = new Date(reincidencia.dataInicioReferencia);
            self.reincidenciaRotina.dataFimReferencia = new Date(reincidencia.dataFimReferencia);
            for (const criterio of criterios) {
              const novoCriterioReincidencia = new CriterioReincidenciaRotina();
              novoCriterioReincidencia.criterioAvaliacaoRotinaCliente = criterio;
              novoCriterioReincidencia.idReincidenciaRotina = self.reincidenciaRotina.idReincidenciaRotina;
              novoCriterioReincidencia.idCriterioAvaliacaoRotinaCliente = criterio.idCriterioAvaliacaoRotinaCliente;
              for (const criterioReincidencia of reincidencia.criterios) {
                if (criterio.idCriterioAvaliacaoRotinaCliente === criterioReincidencia.idCriterioAvaliacaoRotinaCliente) {
                  novoCriterioReincidencia.idCriterioReincidenciaRotina = criterioReincidencia.idCriterioReincidenciaRotina;
                  novoCriterioReincidencia.selecionado = true;
                  break;
                }
              }
              self.criterios.push(novoCriterioReincidencia);
            }
          }
          self.loading = false;
        });
    });
  }

  selecionar(criterio: CriterioReincidenciaRotina, event): void {
    criterio.selecionado = !criterio.selecionado;
    criterio.alterado = true;
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    this.criterios.forEach(criterio => {
      criterio.selecionado = this.selecionados;
      criterio.alterado = true;
    });
  }
  onSubmit(): void {
    if (!this.rangeDatas) {
      this.reincidenciaRotina.dataInicioReferencia = null;
      this.reincidenciaRotina.dataFimReferencia = null;
    }
    if (!this.ultimosDias) {
      this.reincidenciaRotina.diasAte = null;
    }
    if (!this.ultimasSemanas) {
      this.reincidenciaRotina.semanasAte = null;
    }
    if (!this.ultimosMeses) {
      this.reincidenciaRotina.mesesAte = null;
    }
    if (!this.rangeDatas && !this.ultimosDias && !this.ultimasSemanas && !this.ultimosMeses) {
      this.confirmationService.confirm({
        rejectVisible: false,
        message: 'Favor informar um per\u00edodo',
        accept: () => { },
        reject: () => { }
      });

    }
    if (this.rangeDatas && (this.reincidenciaRotina.dataInicioReferencia === undefined
      || this.reincidenciaRotina.dataInicioReferencia === null
      || this.reincidenciaRotina.dataFimReferencia === undefined
      || this.reincidenciaRotina.dataFimReferencia === null)) {
      this.confirmationService.confirm({
        rejectVisible: false,
        message: 'Favor informar ambas as datas',
        accept: () => { },
        reject: () => { }
      });
    } else if (this.rangeDatas && (this.reincidenciaRotina.dataInicioReferencia > this.reincidenciaRotina.dataFimReferencia)) {
      this.confirmationService.confirm({
        rejectVisible: false,
        message: 'A data final tem de ser maior que a data inicial',
        accept: () => { },
        reject: () => { }
      });
    } else {
      let selecionado = false;
      for (const cri of this.criterios) {
        if (cri.selecionado) {
          selecionado = true;
          break;
        }
      }
      if (selecionado) {
        this.loading = true;
        const criteriosInsert = new Array<CriterioReincidenciaRotina>();
        const criteriosRemove = new Array<CriterioReincidenciaRotina>();
        this.criterios.forEach(criterio => {
          if (!criterio.selecionado && criterio.idCriterioReincidenciaRotina !== undefined && criterio.alterado) {
            criteriosRemove.push(criterio);
          } else if (criterio.selecionado && criterio.idCriterioReincidenciaRotina === undefined
            && criterio.alterado) {
            criteriosInsert.push(criterio);
          }
        });
        if (this.MODO === this.CADASTRAR) {
          this._rotinaService.cadastrarReincidenciaRotinaHttp(this.reincidenciaRotina)
            .subscribe(reincidencia => {
              const idReincidenciaRotina = reincidencia.body.idReincidenciaRotina;
              criteriosInsert.forEach(criterioInsert => {
                criterioInsert.idReincidenciaRotina = idReincidenciaRotina;
              });
              this._rotinaService.cadastrarCriteriosReincidenciaRotinaHttp(criteriosInsert)
                .subscribe(response => {
                  this.statusCode = response.status;
                  this._comumService.evento.cadastro = true;
                }, errorCode => {
                  this.statusCode = errorCode;
                });
              this.loading = false;
              this.reincidenciaRotinaEvent.emit(reincidencia.body);
            });
        } else {
          this._rotinaService.atualizarReincidenciaRotinaHttp(this.reincidenciaRotina)
            .subscribe(reincidencia => {
              if (criteriosRemove.length > 0) {
                this._rotinaService.removerCriteriosReincidenciaRotinaHttp(criteriosRemove)
                  .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                  }, errorCode => {
                    this.statusCode = errorCode;
                  });
              }
              if (criteriosInsert.length > 0) {
                this._rotinaService.cadastrarCriteriosReincidenciaRotinaHttp(criteriosInsert)
                  .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                  }, errorCode => {
                    this.statusCode = errorCode;
                  });
              }
              this.reincidenciaRotinaEvent.emit(reincidencia.body);
              this.loading = false;
            });
        }
      } else {
        this.confirmationService.confirm({
          rejectVisible: false,
          message: 'Pelo menos um crit\u00e9rio deve ser selecionado',
          accept: () => { },
          reject: () => { }
        });
      }
    }
  }

  selecionarUltimosDias() {
    this.ultimosDias = true;
    this.ultimasSemanas = false;
    this.ultimosMeses = false;
    this.rangeDatas = false;
  }

  selecionarUltimasSemanas() {
    this.ultimosDias = false;
    this.ultimasSemanas = true;
    this.ultimosMeses = false;
    this.rangeDatas = false;
  }

  selecionarUltimosMeses() {
    this.ultimosDias = false;
    this.ultimasSemanas = false;
    this.ultimosMeses = true;
    this.rangeDatas = false;
  }

  selecionarRangeDatas() {
    this.ultimosDias = false;
    this.ultimasSemanas = false;
    this.ultimosMeses = false;
    this.rangeDatas = true;
  }
}





// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/reincidencia-rotina/reincidencia-rotina.component.ts